/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IconX } from "@tabler/icons-react";
import {
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
} from "../../../apis/locationApis";
import { useLanguage } from "../../../context/LanguageContext";
import {
  useCreateWarehouseMutation,
  useWarehouseListData,
} from "../../../apis/warehouseApi";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useProfileData } from "../../../apis/profileApis";
import Input from "../../../components/Input";
import WarehouseAddressPicker from "./WarehouseAddressPicker";

type FormValues = {
  name: string;
  location: string;
  country: string;
  zipCode: string;
  shortAddress: string;
  city: string;
  district: string;
  latitude?: string;
  longitude?: string;
  status?: boolean;
};

export default function AddWarehouseModals({
  onClose,
}: {
  onClose: () => void;
}) {
  const { t, language } = useLanguage();
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [city, setCity] = useState<any>();
  const [district, setDistrict] = useState<any>(null);
  const { data } = useFetchCountriesAllData();
  const { data: citiesData, refetch: countryRefetch } =
    useFetchCountryCitiesAllData(selectedCountry?.id);

  const { mutate, isPending } = useCreateWarehouseMutation();
  const { refetch } = useWarehouseListData();
  const { refetch: profileFetch } = useProfileData();
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  const handleContinue = (data: FormValues) => {
    mutate(
      {
        ...data,
        country: selectedCountry?.id,
        city: city?.id || data.city,
        district: district?.id || data.district,
      },
      {
        onSuccess: () => {
          onClose();
          profileFetch();
          toast.success("Warehouse Added Successfully.");
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  useEffect(() => {
    if (selectedCountry?.id) {
      countryRefetch();
    }
  }, [selectedCountry]);

  return (
    <>
      <div 
        dir={language === "ar" ? "rtl" : "ltr"}
        className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4 text-[#1E293B]"
      >
        <div className="rounded-2xl xl:w-6/12 lg:w-8/12 w-11/12 relative bg-[#FAF8EC]">
          <div className="flex items-center">
            <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
              <h1 className="text-2xl">{t("Create Warehouse")}</h1>
            </div>
            <div className="relative ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={38}
                height={37}
                viewBox="0 0 38 37"
                fill="none"
                className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
              >
                <path
                  d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                  fill="#F7F6F2"
                />
              </svg>

              <button
                onClick={onClose}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
              >
                <IconX size={20} />
              </button>
            </div>
          </div>
          <div className="w-full  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
            <div className=" h-[calc(100vh-10rem)] overflow-y-auto space-y-4 pt-0 p-4 scrollbar-clean">
              <div className="grid grid-cols-6 gap-4 overflow-hidden">
                <div className="col-span-6">
                  <Input
                    name="name"
                    type="text"
                    title="Warehouse Name"
                    placeholder="Main Riyadh "
                    other={{
                      className:
                        "w-full space-y-1 px-4 py-2 text-sm rounded-full outline-none bg-white border border-[#D8D8D8] focus:border-[#4F6EF7]",
                    }}
                    register={register}
                    error={errors?.name}
                    validation={{
                      required: "Warehouse name is required",
                      pattern: {
                        value: /^(?=.*[A-Za-z\u0600-\u06FF])[A-Za-z\u0600-\u06FF0-9\s-]+$/,
                        message:
                          "Warehouse Name must include at least one letter (not only numbers)",
                      },
                      validate: (value: string) => {
                        const trimmed = value.trim();
                        if (trimmed.length < 3)
                          return "Warehouse name must be at least 3 characters";
                        if (trimmed.length > 30)
                          return "Warehouse name must be at most 30 characters";
                        if (!value?.trim())
                          return "Warehouse Name cannot be empty or only spaces";
                        return true;
                      },
                    }}
                  />
                </div>

                <WarehouseAddressPicker
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  control={control}
                  clearErrors={clearErrors}
                  countries={data || []}
                  cities={citiesData || []}
                  selectedCountry={selectedCountry}
                  selectedCity={city}
                  selectedDistrict={district}
                  onCountryChange={setSelectedCountry}
                  onCityChange={setCity}
                  onDistrictChange={setDistrict}
                />
              </div>
            </div>
          </div>
          <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] ">
            <button
              onClick={handleSubmit(handleContinue)}
              disabled={isPending}
              className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium disabled:opacity-50"
            >
              {isPending ? (
                <>
                  <svg className="animate-spin h-4 w-4 mr-2 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                  </svg>
                  <span>Submitting...</span>
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
